import { useEffect, useState } from "react";
import { createTrainer, fetchTrainers } from "@/api/academyAuth";

export default function CreateTrainer() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });

  const [trainers, setTrainers] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const loadTrainers = async () => {
    try {
      const data = await fetchTrainers();
      setTrainers(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadTrainers();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsSubmitting(true);

    try {
      await createTrainer(form);

      setSuccess("تم إنشاء المدرب بنجاح");
      setForm({
        name: "",
        email: "",
        password: "",
        phone: "",
      });

      loadTrainers();
    } catch {
      setError("فشل إنشاء المدرب");
    } finally {
      setIsSubmitting(false);
    }
  };

  // تنسيقات CSS
  const styles = {
    container: {
      maxWidth: "1200px",
      margin: "0 auto"
    },
    header: {
      marginBottom: "30px",
      paddingBottom: "20px",
      borderBottom: "2px solid #e9ecef"
    },
    title: {
      margin: "0 0 10px 0",
      color: "#182848",
      fontSize: "28px",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },
    subtitle: {
      margin: "0",
      color: "#6c757d",
      fontSize: "16px"
    },
    twoColumns: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "30px",
      marginBottom: "30px"
    },
    card: {
      backgroundColor: "white",
      borderRadius: "15px",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.05)",
      padding: "25px"
    },
    cardTitle: {
      margin: "0 0 25px 0",
      color: "#182848",
      fontSize: "20px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      paddingBottom: "15px",
      borderBottom: "1px solid #e9ecef"
    },
    form: {
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    },
    formGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "8px"
    },
    label: {
      color: "#495057",
      fontWeight: "500",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      gap: "5px"
    },
    required: {
      color: "#dc3545"
    },
    input: {
      padding: "14px 16px",
      border: "1px solid #e1e5eb",
      borderRadius: "10px",
      fontSize: "16px",
      transition: "all 0.3s",
      backgroundColor: "#f8f9fa",
      boxSizing: "border-box",
      fontFamily: "inherit",
      width: "100%"
    },
    inputFocus: {
      outline: "none",
      borderColor: "#4b6cb7",
      boxShadow: "0 0 0 3px rgba(75, 108, 183, 0.1)",
      backgroundColor: "white"
    },
    submitButton: {
      padding: "15px 25px",
      background: "linear-gradient(90deg, #4b6cb7 0%, #182848 100%)",
      color: "white",
      border: "none",
      borderRadius: "10px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.3s",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      marginTop: "10px",
      fontFamily: "inherit"
    },
    submitButtonDisabled: {
      opacity: "0.7",
      cursor: "not-allowed"
    },
    spinner: {
      width: "20px",
      height: "20px",
      border: "2px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "50%",
      borderTopColor: "white",
      animation: "spin 1s ease-in-out infinite"
    },
    successMessage: {
      backgroundColor: "#d4edda",
      border: "1px solid #c3e6cb",
      color: "#155724",
      padding: "15px",
      borderRadius: "10px",
      marginTop: "15px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "15px",
      animation: "fadeIn 0.3s ease-out"
    },
    errorMessage: {
      backgroundColor: "#f8d7da",
      border: "1px solid #f5c6cb",
      color: "#721c24",
      padding: "15px",
      borderRadius: "10px",
      marginTop: "15px",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      fontSize: "15px",
      animation: "fadeIn 0.3s ease-out"
    },
    icon: {
      width: "20px",
      height: "20px",
      flexShrink: "0"
    },
    trainersList: {
      listStyle: "none",
      margin: "0",
      padding: "0",
      display: "grid",
      gap: "15px"
    },
    trainerItem: {
      backgroundColor: "white",
      borderRadius: "10px",
      padding: "20px",
      border: "1px solid #e9ecef",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      transition: "all 0.3s"
    },
    trainerInfo: {
      display: "flex",
      alignItems: "center",
      gap: "15px"
    },
    trainerAvatar: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#4b6cb7",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "600",
      fontSize: "18px",
      flexShrink: "0"
    },
    trainerDetails: {
      display: "flex",
      flexDirection: "column",
      gap: "5px"
    },
    trainerName: {
      margin: "0",
      color: "#182848",
      fontSize: "16px",
      fontWeight: "600"
    },
    trainerEmail: {
      margin: "0",
      color: "#6c757d",
      fontSize: "14px"
    },
    trainerPhone: {
      margin: "0",
      color: "#6c757d",
      fontSize: "14px",
      display: "flex",
      alignItems: "center",
      gap: "5px"
    },
    emptyState: {
      textAlign: "center",
      padding: "40px 20px",
      color: "#6c757d"
    },
    emptyIcon: {
      fontSize: "48px",
      marginBottom: "15px",
      opacity: "0.5"
    },
    emptyText: {
      margin: "0",
      fontSize: "16px"
    },
    statsCards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gap: "20px",
      marginBottom: "30px"
    },
    statCard: {
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 3px 10px rgba(0, 0, 0, 0.08)",
      display: "flex",
      alignItems: "center",
      gap: "15px",
      transition: "all 0.3s"
    },
    statIcon: {
      width: "50px",
      height: "50px",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: "0",
      backgroundColor: "rgba(75, 108, 183, 0.1)"
    },
    statContent: {
      flex: "1"
    },
    statTitle: {
      margin: "0 0 5px 0",
      color: "#6c757d",
      fontSize: "14px",
      fontWeight: "500"
    },
    statValue: {
      margin: "0",
      color: "#182848",
      fontSize: "24px",
      fontWeight: "700"
    },
    sectionDivider: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      margin: "40px 0 25px 0",
      color: "#6c757d"
    },
    dividerLine: {
      flex: "1",
      height: "1px",
      backgroundColor: "#e9ecef"
    },
    dividerText: {
      margin: "0",
      fontSize: "18px",
      fontWeight: "600",
      color: "#182848"
    }
  };

  // أيقونات SVG
  const TrainerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ ...styles.icon, color: "#4b6cb7" }}>
      <path fillRule="evenodd" d="M8.25 6.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM15.75 9.75a3 3 0 116 0 3 3 0 01-6 0zM2.25 9.75a3 3 0 116 0 3 3 0 01-6 0zM6.31 15.117A6.745 6.745 0 0112 12a6.745 6.745 0 016.709 7.498.75.75 0 01-.372.568A12.696 12.696 0 0112 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 01-.372-.568 6.787 6.787 0 011.019-4.38z" clipRule="evenodd" />
      <path d="M5.082 14.254a8.287 8.287 0 00-1.308 5.135 9.687 9.687 0 01-1.764-.44l-.115-.04a.563.563 0 01-.373-.487l-.01-.121a3.75 3.75 0 013.57-4.047zM20.226 19.389a8.287 8.287 0 00-1.308-5.135 3.75 3.75 0 013.57 4.047l-.01.121a.563.563 0 01-.373.486l-.115.04c-.567.2-1.156.349-1.764.441z" />
    </svg>
  );

  const SuccessIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ ...styles.icon, color: "#155724" }}>
      <path fillRule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clipRule="evenodd" />
    </svg>
  );

  const ErrorIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ ...styles.icon, color: "#721c24" }}>
      <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
    </svg>
  );

  const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ ...styles.icon, color: "#4b6cb7" }}>
      <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
    </svg>
  );

  const PhoneIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "14px", height: "14px", color: "#6c757d" }}>
      <path fillRule="evenodd" d="M1.5 4.5a3 3 0 013-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 01-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 006.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 011.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 01-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5z" clipRule="evenodd" />
    </svg>
  );

  // دالة لمعالجة التركيز على الحقول
  const handleInputFocus = (e) => {
    e.target.style.outline = "none";
    e.target.style.borderColor = "#4b6cb7";
    e.target.style.boxShadow = "0 0 0 3px rgba(75, 108, 183, 0.1)";
    e.target.style.backgroundColor = "white";
  };

  const handleInputBlur = (e) => {
    e.target.style.borderColor = "#e1e5eb";
    e.target.style.boxShadow = "none";
    e.target.style.backgroundColor = "#f8f9fa";
  };

  // دالة لمعالجة تأثيرات hover على الأزرار
  const handleButtonHover = (e) => {
    if (!isSubmitting) {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 7px 14px rgba(75, 108, 183, 0.2)";
    }
  };

  const handleButtonLeave = (e) => {
    if (!isSubmitting) {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }
  };

  // دالة لمعالجة تأثيرات hover على عناصر المدربين
  const handleTrainerHover = (e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow = "0 5px 15px rgba(0, 0, 0, 0.1)";
    e.currentTarget.style.borderColor = "#4b6cb7";
  };

  const handleTrainerLeave = (e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "0 0 0 rgba(0, 0, 0, 0)";
    e.currentTarget.style.borderColor = "#e9ecef";
  };

  // الحصول على الأحرف الأولى من الاسم لعرضها في الصورة الرمزية
  const getInitials = (name) => {
    return name
      .split(" ")
      .map(word => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div style={styles.container}>
      {/* رأس الصفحة */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <TrainerIcon />
          إدارة المدرّبين
        </h1>
        <p style={styles.subtitle}>قم بإضافة وتعديل مدرّبي الأكاديمية</p>
      </div>

      {/* إحصائيات سريعة */}
      <div style={styles.statsCards}>
        <div style={styles.statCard}>
          <div style={styles.statIcon}>
            <UserIcon />
          </div>
          <div style={styles.statContent}>
            <h3 style={styles.statTitle}>إجمالي المدرّبين</h3>
            <p style={styles.statValue}>{trainers.length}</p>
          </div>
        </div>
      </div>

      {/* محتوى الصفحة في عمودين */}
      <div style={styles.twoColumns}>
        {/* العمود الأيسر: نموذج الإضافة */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>إضافة مدرّب جديد</h2>
          
          <form onSubmit={submit} style={styles.form}>
            <div style={styles.formGroup}>
              <label style={styles.label}>
                الاسم الكامل
                <span style={styles.required}>*</span>
              </label>
              <input
                placeholder="أدخل الاسم الكامل للمدرّب"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                البريد الإلكتروني
                <span style={styles.required}>*</span>
              </label>
              <input
                type="email"
                placeholder="example@email.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                كلمة المرور
                <span style={styles.required}>*</span>
              </label>
              <input
                type="password"
                placeholder="أدخل كلمة مرور قوية"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                required
                style={styles.input}
                minLength="6"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>
                رقم الهاتف
              </label>
              <input
                placeholder="05XXXXXXXX"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                style={styles.input}
              />
            </div>

            <button 
              type="submit" 
              style={{
                ...styles.submitButton,
                ...(isSubmitting ? styles.submitButtonDisabled : {})
              }}
              disabled={isSubmitting}
              onMouseEnter={handleButtonHover}
              onMouseLeave={handleButtonLeave}
            >
              {isSubmitting ? (
                <>
                  <div style={styles.spinner}></div>
                  جاري الإنشاء...
                </>
              ) : (
                "إنشاء مدرّب"
              )}
            </button>

            {/* رسائل النجاح والخطأ */}
            {success && (
              <div style={styles.successMessage}>
                <SuccessIcon />
                {success}
              </div>
            )}

            {error && (
              <div style={styles.errorMessage}>
                <ErrorIcon />
                {error}
              </div>
            )}
          </form>
        </div>

        {/* العمود الأيمن: قائمة المدرّبين */}
        <div style={styles.card}>
          <h2 style={styles.cardTitle}>المدرّبون الحاليون ({trainers.length})</h2>
          
          {trainers.length === 0 ? (
            <div style={styles.emptyState}>
              <div style={styles.emptyIcon}>👨‍🏫</div>
              <p style={styles.emptyText}>لا يوجد مدرّبون مسجّلون بعد</p>
            </div>
          ) : (
            <ul style={styles.trainersList}>
              {trainers.map((trainer) => (
                <li 
                  key={trainer.id}
                  style={styles.trainerItem}
                  onMouseEnter={handleTrainerHover}
                  onMouseLeave={handleTrainerLeave}
                >
                  <div style={styles.trainerInfo}>
                    <div style={styles.trainerAvatar}>
                      {getInitials(trainer.name || "مدرّب")}
                    </div>
                    <div style={styles.trainerDetails}>
                      <h4 style={styles.trainerName}>{trainer.name}</h4>
                      <p style={styles.trainerEmail}>{trainer.email}</p>
                      {trainer.phone && (
                        <p style={styles.trainerPhone}>
                          <PhoneIcon />
                          {trainer.phone}
                        </p>
                      )}
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* إضافة الأنيميشن */}
      <style>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .trainer-item {
          animation: fadeIn 0.3s ease-out;
        }
        
        @media (max-width: 992px) {
          .two-columns {
            grid-template-columns: 1fr !important;
          }
        }
        
        @media (max-width: 768px) {
          .stats-cards {
            grid-template-columns: 1fr !important;
          }
          
          .card {
            padding: 20px !important;
          }
        }
      `}</style>
    </div>
  );
}